// ChannelLabel.jsx

import React from "react";

const ChannelLabel = ({ label }) => {
  return <span>{label}</span>
};

export default ChannelLabel;
